import {TinyActivity} from "@/types";

export class ActivityOccurrence {
  id?: string
  startDate?: string
  endDate?: string
  occupiedPlaces?: number
  slug?: string
  activity: TinyActivity

  constructor() {
    this.activity = {}
  }
}